<script lang="ts" setup>
	import { XCircleIcon, XMarkIcon } from '@heroicons/vue/24/outline';

	defineEmits<{
		(e: 'close'): void;
	}>();
</script>
<template>
	<div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5">
		<div class="p-4">
			<div class="flex items-start">
				<div class="shrink-0">
					<XCircleIcon class="h-6 w-6 text-red-400" />
				</div>
				<div class="ml-3 w-0 flex-1 pt-0.5">
					<div class="flex-1 space-y-4 text-sm font-medium leading-5 text-gray-900">
						<slot />
					</div>
				</div>
				<div class="ml-4 flex shrink-0">
					<button
						class="focus:outline-hidden inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
						@click="$emit('close')"
					>
						<span class="sr-only">Close</span>
						<XMarkIcon class="h-5 w-5"></XMarkIcon>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
